import request from '@/utils/request'

//部门管理



//留言板新增留言
export function addMessage(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/message/add",
    data: data
  })
}
// 留言板回复
export function editMessage(data) {
  return request({
    method: 'put',
    url: "/yzdservice/api/message/edit",
    data: data
  })
}
//留言板分页
export function getMsgManage(data) {
  return request({
    method: 'post',
    url: "/yzdservice/api/message/manage/all",
    data: data
  })
}
//查看留言板详情
export function getMessageInfo(id) {
  return request({
    method: 'get',
    url: "/yzdservice/api/message/info/" + id
  })
}
//留言板类型下拉
export function getTypeList() {
  return request({
    method: 'get',
    url: "/yzdservice/api/message/type/list"
  })
}
//保存图片
export function saveFileYs(data) {
  return request({
    method: 'post',
    url: "/yzdservice/common/saveFileYs?isMessage=true",
    data: data
  })
}
